import { ReferenceState } from './types';

export const state = (): ReferenceState => initialState();

export const initialState = (): ReferenceState => ({
  references: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['name'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['Name'],
    },
  },
});
